import { createGlobalStyle } from 'styled-components';
import { media } from './style-utils';
import { legacyType } from './typography';

export default createGlobalStyle`
  html {
    box-sizing: border-box;
    scroll-behavior: smooth;
    height: 100%; /* Needed for the external player */
  }

  *,
  *::before,
  *::after { box-sizing: inherit; }

  body {
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    background-color: var(--c-shark);
    color: var(--c-white);
    font-family: var(--ff-display);
    font-size: var(--fs-focus);
    font-weight: 400;
    ${legacyType('base', 'body')};
    margin: 0;
    margin-left: auto;
    margin-right: auto;
    max-width: 2100px;
  }

  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 1200;
    background-color: rgba(0, 0, 0, 0.5);
  }

  .overlay--animated {
    opacity: 0;
    transition: opacity 300ms ease;

    &.ReactModal__Overlay--after-open {
      opacity: 1;
    }

    &.ReactModal__Overlay--before-close {
      opacity: 0;
    }
  }

  br {
    display: inline;
  }

  html, body, #root {
    height: 100%;
  }

  button,
  input,
  optgroup,
  select,
  textarea {
    border-radius: 0;
    font-family: inherit;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  p { margin-top: 0; }

  a {
    color: inherit;
    cursor: pointer;
    text-decoration: none;
  }

  p a:hover { text-decoration: underline; }

  h1,
  h2,
  h3,
  h4,
  h5,
  p,
  dl { margin-top: 0; }

  h1,
  h2,
  h3,
  h4,
  h5 { font-family: var(--ff-display) }

  h1 {
    font-size: var(--fs-xl);
    font-weight: 600;
    ${legacyType('xl', 'display', { emphasis: true })};
    margin-bottom: calc(var(--fr));

    ${media.mediumLarge`
      margin-bottom: calc(var(--fr) * 2);
    `}
  }

  h2 {
    font-size: var(--fs-xl);
    font-weight: 600;
    ${legacyType('xl', 'display', { emphasis: true })};
    margin-bottom: calc(var(--fr));
  }

  h3 {
    font-size: var(--fs-ml);
    font-weight: 600;
    ${legacyType('ml', 'headline', { emphasis: true })};
    margin-bottom: var(--fr);
  }

  h4 {
    font-size: var(--fs-m);
    font-weight: 600;
    ${legacyType('m', 'headline', { emphasis: true })};
    margin-bottom: var(--fr);
  }

  h5 { 
    font-size: var(--fs-sm);
    font-weight: 600;
    ${legacyType('sm', 'title', { emphasis: true })};
    margin-bottom: var(--fr);
  }

  h6 {
    margin-top: 0;
    font-weight: 400;
    font-size: var(--fs-focus);
    color: var(--c-manatee);
    margin-bottom: 0;
  }

  hr {
    border: 0.5px solid var(--c-slate);
    margin: calc(var(--fr) * 1.5) auto;
  }

  p { 
    font-size: var(--fs-sm);
    ${legacyType('sm', 'body')};
    margin-bottom: var(--fr); 
  }

  strong,
  .u-fw-500 { font-weight: 500; }

  ol,
  ul {
    list-style-type: none;
    margin-bottom: 0;
    margin-top: 0;
    padding-left: 0;
  }

  dd { margin-left: 0; }

  button {
    background-color: transparent;
    border: medium none;
    color: inherit;
    cursor: pointer;
    font-weight: 500;
    padding: 0;
    vertical-align: top;
  }

  input {
    border: 0 none;
    display: block;
    width: 100%;
  }

  input::-ms-clear { display: none; }

  picture { display: block; }

  img { width: 100%; height: auto; }

  figure { margin: 0; }

  [data-whatintent='mouse'] *:focus { outline: none; }

  [data-whatintent='keyboard'] *:focus { outline: 2px solid var(--c-silver); }

  [data-whatintent='keyboard'] .app-chrome-glass :focus { outline-color: var(--c-white); }

  .content {
    -ms-grid-column: 1; /* stylelint-disable-line property-no-vendor-prefix */
    -ms-grid-column-span: 1; /* stylelint-disable-line property-no-vendor-prefix */
    -ms-grid-row: 2; /* stylelint-disable-line property-no-vendor-prefix */
    -ms-grid-row-span: 1; /* stylelint-disable-line property-no-vendor-prefix */
    -webkit-overflow-scrolling: touch;
    transform: translateZ(0);

    @supports(display:grid) { grid-area: content; }
  }

  .modalOpen {
    overflow: hidden;
  }

  .dummy-btn {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
  }

  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
  }
`;



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/styles/global.js